(function(angular){
	'use strict';

	angular
		.module('recurringInvestmentModule',
			[
				'amountSelectModule',
				'confirmationModalModule',
				'coreModule',
				'momentModule',
				'optionsModule',
				'progressIndicatorModule',
				'settingsModule'
			])
		.value('globalConfig', globalConfig);
})(window.angular);
